class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this;
    this.body = document.querySelector('body');
    this.activeClass = 'cart-drawer-is-open';
    this.cartIconBubble = document.querySelector('cart-icon-bubble');

    this.closeButtons = this.querySelectorAll('[data-cart-button-close]');
    this.closeButtons.forEach((btn) => btn.addEventListener('click', this.close.bind(this)));

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  open() {
    sessionStorage.setItem('cart_is_open', true);
    this.body.classList.add(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', true);

    this.drawer.focus();
    trapFocus(this.drawer);
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.body.classList.remove(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', false);

    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus();
  }

  renderContents(parsedState) {

    this.getSectionsToRender().forEach((section) => {
      if (section?.selector) {
        const selector = document.querySelector(section.selector);

        if (selector) {
          selector.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        }
      }
    });

    // Re-bind the close drawer buttons
    this.querySelectorAll('[data-cart-button-close]').forEach((btn) =>
      btn.addEventListener('click', this.close.bind(this))
    );

    this.handleDiscounts();
    this.handlePromos();
  }

  handleDiscounts() {
    let discountCode = localStorage.getItem('discounts_applied_updated');
    if (discountCode) {
      document.querySelectorAll('[data-storewide-discount]').forEach((discount) => {
        let newPrice = discount.querySelector('.price__item--compare').innerHTML;
        let oldPrice = discount.querySelector('.price__item--regular').innerHTML;
        discount.querySelector('.price__item--regular').innerHTML = newPrice;
        discount.querySelector('.price__item--compare').innerHTML = oldPrice;
        discount.querySelector('.price__item--compare').classList.remove('hidden');

      });
      document.querySelectorAll('[data-storewide-discount-bundle]').forEach((discount) => {
        let newPrice = discount.querySelector('[data-discount-new-price]').dataset.discountNewPrice;
        discount.querySelector('[data-discount-new-price]').innerHTML = newPrice;
      });
    }
  }

  // product promos
  handlePromos() {
    if (document.querySelector('[data-product-drawer-promos]')) {
      let promos = document.querySelector('[data-product-drawer-promos]');
      if (promos.dataset && promos.dataset.productDrawerPromos) {
        let promoData = JSON.parse(promos.dataset.productDrawerPromos);
        let enable_promo = promoData.promo_enabled;

        if (enable_promo) {
          let promo_variant_id = promoData.promo_variant_id;
          let add_product = promoData.add_product;

          // add product
          if (add_product) {

            let properties = {};
            properties._promo_product = 'true';
            
            let body = JSON.stringify({
              id: promo_variant_id,
              quantity: 1,
              properties,
              sections: this.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname
            });
            
            fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
              .then((response) => response.json())
              .then((parsedState) => {
                this.renderContents(parsedState);
              })
              .catch((e) => {
                console.error(e);
              })
          }
        }
      }
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '[data-cart-drawer]',
      },
      {
        id: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.drawer && !target.closest('cart-drawer')) {
      this.close();
    }
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
